(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-compare-slider"] && !Shopify.designMode) return;
  try {
    
  const checkcompareSplide = () => {
    if (Splide) {      
      var splide = new Splide( '.custom-compare-slider-parent.splide', {
        pagination: true,
        perPage: 1,
        perMove: 1,
        arrows: false,
        autoplay: true,
        interval: 9000,
        type   : 'loop'
      }).mount()      
    } else {
      setTimeout(() => checkcompareSplide(), 100)
    }
  }

  document.addEventListener( 'DOMContentLoaded', function() {
    checkcompareSplide()
  } );

  } catch(e) { console.error(e); }
})();
})();
